export const PricingTableFeatureData: Array<{
    title: string;
    description?: string;
    premium?: boolean;
}> = [
    {
        title: "Play instant games",
        description: "Pick a random prompt and start writing with your class in minutes.",
    },
    {
        title: "Thousands of images",
        description: "Every game gets a visual prompt from our library.",
    },
    {
        title: "Adjust game settings",
        description: "Control timers, rounds, and player options for your class.",
    },
    {
        title: "Review student writing",
        description: "Read, approve, and manage responses during and after games.",
    },
    {
        title: "1,000+ curriculum prompts",
        description: "Ready-to-use prompts for all kinds of writing.",
        premium: true,
    },
    {
        title: "Create your own prompts",
        description: "Design games matched to any text, topic, or unit you're teaching.",
        premium: true,
    },
    {
        title: "Upload your own images",
        description: "Use your own stimulus images to suit your students or topic.",
        premium: true,
    },
    {
        title: "Classes and portfolios",
        description: "Organise students into classes and track their writing over time.",
        premium: true,
    },
    {
        title: "Team play and homework mode",
        description: "Run games in small groups or assign them for independent work.",
        premium: true,
    },
    {
        title: "Writelike access",
        description: "Teach with our companion mentor-text modelling resource.",
        premium: true,
    },
];
